import { useEffect, useRef, useCallback } from 'react'
import { useSelector } from 'react-redux'
//
import { selectPictureOrigin } from 'redux/selector/app'
import { fetchBinFile, fetchPostAdEvent, SchemaOholoMaterialShow } from 'api'
import { imageParser } from 'utils/imageParser'
import { Image } from './Styled'
import { formatDate } from 'utils/timeFormat'
import { catchPromiseCancel } from 'utils/catchPromiseCancel'

export default function CarouselItem(info: SchemaOholoMaterialShow) {
  const pictureOrigin = useSelector(selectPictureOrigin)
  const imgRef = useRef<HTMLImageElement>(null)

  const onAdItemClick = useCallback(() => {
    if (info) {
      fetchPostAdEvent({
        date: formatDate(new Date()),
        material_id: info.id,
        material_name: info.name,
        oholo_site_id: info.site_type,
        oholoer_id: info.oholoer_id,
        oholoer_link: info.oholoer_link,
        oholoer_name: info.oholoer_name,
      })
      window.open(info?.link, '_blank')
    } else {
      console.warn('no ad assigned')
    }
  }, [info])

  useEffect(() => {
    const image = imgRef.current
    if (!pictureOrigin || !info.icon_path || !image || image.src) return

    const controller = new AbortController()
    const shortcutImagePath = `${pictureOrigin}/${info.icon_path}`

    let url: string
    fetchBinFile({
      url: shortcutImagePath,
      signal: controller.signal,
    })
      .then((textBase64) => (url = image.src = imageParser(textBase64)))
      .catch(catchPromiseCancel)

    return () => {
      if (url) URL.revokeObjectURL(url)
      controller.abort()
    }
  }, [pictureOrigin, info])

  return <Image ref={imgRef} onClick={onAdItemClick} />
}
